module.exports = __webpack_public_path__ + "img/setup-analytics-animate.b469a228.svg";